module.exports = __webpack_public_path__ + "media/svg-new/icon-simulado-f6ad5409.svg";